import { AppointmentWUT } from '@wix/form-fields/viewer-wut';

export default AppointmentWUT;
